if (!customElements.get("social-share-content")) {
  customElements.define(
    "social-share-content",
    class ShareContent extends HTMLElement {
      connectedCallback() {
        this.updateShareUrls();
      }

      updateShareUrls() {
        const shareLinks = this.querySelectorAll(".share-content__link");
        shareLinks.forEach((link) => {
          const platform = link.getAttribute("data-share");
          const urlToShare = link.getAttribute("data-url");
          let shareUrl;

          switch (platform) {
            case "twitter":
              shareUrl = `https://twitter.com/share?url=${urlToShare}`;
              break;
            case "facebook":
              shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${urlToShare}`;
              break;
            case "pinterest":
              const media = link.getAttribute("data-media");
              const title = link.getAttribute("data-title");
              shareUrl = `https://pinterest.com/pin/create/button/?url=${urlToShare}&media=${media}&description=${title}`;
              break;
            case "google":
              shareUrl = `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=Check%20this%20out&body=${urlToShare}`;
              break;
            case "copy":
              link.addEventListener("click", (event) => {
                event.preventDefault();
                navigator.clipboard
                  .writeText(urlToShare)
                  .then(() => console.log("Link copied to clipboard!"))
                  .catch((err) => console.error("Failed to copy link: ", err));
              });
              return;
          }

          if (platform !== "copy") {
            link.setAttribute("href", shareUrl);
          }
        });
      }
    }
  );
}
